import React from 'react';
import './Modal.css'
import './ModalMobile.css'



class Modal extends React.Component {
    constructor(props) {
      super(props);
      this.review_array = ["first page", "second page", "third page"]
      this.state = {
        lpg: true,
        review_element: 0
      }
    }

    handleClickEvent = (e) => {
        e.preventDefault();
        if (e.target.className.includes('modal-wrapper')) {
            this.closeModal();
        } 
        else {
            const bodyWidth = document.body.getBoundingClientRect().width
            console.log(`Body Width is: ${bodyWidth} and client X is ${e.clientX}`)
            if (e.clientX >= bodyWidth/2) {
                this.passPage(true);
            } else {
                this.passPage(false);
            }
        }
    }

    closeModal = () => {
        console.log('closingModal');
        this.props.setShowModal(false);
    }

    passPage = (fwd) => {
        if (fwd) {
            // Get next piece of text
            console.log('passingPageForward');
            if (this.state.review_element === (this.review_array.length - 1)) {
                return
            } else {
                this.setState({review_element: this.state.review_element+1})
            }
        } else {
            // Get previous piece of text
            console.log('passingPageBackward');
            if (this.state.review_element === 0) {
                return
            } else {
                this.setState({review_element: this.state.review_element-1})
            }
        }
        this.setState({lpg: !this.state.lpg});
    }

    render() {
        return (this.props.showModal) ? (
                    <div className="background" onClick={(e) => this.handleClickEvent(e)}>
                        <div className={this.state.lpg ? "modal-wrapper lbgi" : "modal-wrapper rbgi"}>
                            {this.state.lpg ? (
                                <>
                                    <img alt="" src={require("../images/modal_lpg.png")}/>
                                    <div className="modal-left-side">
                                        <p className="title">
                                            {this.review_array[this.state.review_element]}
                                        </p>
                                    </div>
                                </>
                                ) : (
                                <>
                                    <img alt="" src={require("../images/modal_rpg.png")}/>
                                    <div className="modal-right-side">
                                        <p className="title">
                                            {this.review_array[this.state.review_element]}
                                        </p>
                                    </div>
                                </>
                                )
                            }
                        </div>
                    </div>
                ) : "";
    }
}

export default Modal;